import EnforcementAction from "../../redux/actions/EnforcementAction";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { yupResolver } from "@hookform/resolvers/yup";
import { enforcementSchema } from "@common/components/helpers/validation-schemas/enforcementSchema";
import { useEffect } from "react";
import fetchEnforcementTypes from "@common/components/helpers/Enforcement/fetchEnforcementTypes";
import { fetchPoliceId } from "../helpers/Officer/searchOfficer";
import useCompliance from "./useCompliance";

export const useEnforcement = () => {
  const { formData } = useSelector((state) =>
    EnforcementAction.getStatePath(state),
  );

  const methods = useForm({
    resolver: yupResolver(enforcementSchema),
    defaultValues: formData,
    mode: "all",
  });

  useEffect(fetchEnforcementTypes, []);

  useEffect(fetchPoliceId, []);

  const { resetComplianceForms } = useCompliance(methods);

  const handleBack = () => resetComplianceForms();

  return { methods, handleBack };
};
